import { languages } from "@/data/trinityI18n";
import { BrandLockup } from "./BrandLockup";

const navItems = [
  { sectionKey: "snapshot", target: "#overview", labelIndex: 0 },
  { sectionKey: "milestones", target: "#milestones", labelIndex: 1 },
  { sectionKey: "proof", target: "#projects", labelIndex: 2 },
  { sectionKey: "capabilities", target: "#capabilities", labelIndex: 3 },
  { sectionKey: "global", target: "#global", labelIndex: 4 },
];

export function Header({ content, language, onLanguageChange, visibleSections = [] }) {
  const visibleSectionSet = new Set(visibleSections);
  const visibleNavItems = navItems.filter((item) => visibleSectionSet.size === 0 || visibleSectionSet.has(item.sectionKey));

  return (
    <header className="site-header" data-testid="main-header">
      <a className="brand-mark" href="#top" data-testid="header-brand-link" aria-label="Trinity Electronic home">
        <BrandLockup testIdPrefix="header-brand" />
      </a>

      <nav className="desktop-nav" data-testid="header-navigation" aria-label="Primary navigation">
        {visibleNavItems.map((item, index) => (
          <a key={item.sectionKey} href={item.target} data-nav-section={item.sectionKey} data-testid={`nav-link-${index + 1}`}>
            {content.nav[item.labelIndex]}
          </a>
        ))}
      </nav>

      <div className="header-actions" data-testid="header-actions">
        <div className="language-switcher" data-testid="language-switcher" aria-label="Language selector">
          {languages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              className={language === lang.code ? "active" : ""}
              onClick={() => onLanguageChange(lang.code)}
              data-testid={`language-button-${lang.code}`}
              aria-pressed={language === lang.code}
            >
              {lang.short}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}